import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import * as actions from '../../store/modules/menu/actions'
import { MenuContainer, Logo, Nav } from './styles'
// import logo from '../../assets/treelogo4.svg'
// import logo from '../../assets/treelogo4.svg'
// import logo from '../../assets/treelogo4.svg'
import logoMenor from '../../assets/tree-new-verde-2.svg'
import logoMaior from '../../assets/tree-new-verde.svg'
import {
    MdOutlineClose,
    MdOutlineHelpOutline,
    MdOutlineInsertChartOutlined,
    MdOutlineKeyboardArrowRight,
    MdOutlineLightMode,
    MdOutlineNightlight,
    MdPeopleOutline,
} from 'react-icons/md'
import { RiExchangeDollarLine } from 'react-icons/ri'
import { FiSettings, FiFileText } from 'react-icons/fi'
import { BiDollarCircle, BiLink } from 'react-icons/bi'
import { useMediaQuery } from '@mui/material'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import classNames from 'classnames'
import { Switch } from '@headlessui/react'

interface MenuProps {
    isMenuOpen: boolean
    setIsMenuOpen: (valor: boolean) => void
}

export default function Menu({ isMenuOpen, setIsMenuOpen }: MenuProps) {
    const { mainMenu, colorDark } = useSelector(
        (state: StoreState) => state.menu
    )
    const dispatch = useDispatch()
    const [showDashboard, setShowDashboard] = useState(false)
    const [showCredit, setShowCredit] = useState(false)
    const [showLink, setShowLink] = useState(false)
    const menuClosesOnClickIn = useMediaQuery('(max-width:1200px)')
    const collapseMenuIcon = useMediaQuery('(min-width:678px)')
    const handleOpenOrCloseMenuBasedOnWidth =
        useMediaQuery('(min-width:1200px)')
    const [enabled, setEnabled] = useState(true)

    useEffect(() => {
        if (handleOpenOrCloseMenuBasedOnWidth) return setIsMenuOpen(true)
        return setIsMenuOpen(false)
    }, [handleOpenOrCloseMenuBasedOnWidth, setIsMenuOpen])

    useEffect(() => {
        if (mainMenu === 'Dashboard') setShowDashboard(true)
        if (mainMenu === 'Créditos') setShowCredit(true)
    }, [mainMenu])

    function handleClickLinkWithMatches() {
        if (menuClosesOnClickIn) setIsMenuOpen(false)
    }

    function handleClickMenu(
        mainMenu: string,
        subMenu: string,
        currentLink: string = ''
    ) {
        const dashboardConditionToClose =
            showDashboard && mainMenu !== 'Dashboard'
        if (dashboardConditionToClose) setShowDashboard(false)

        const creditosConditionToClose = showCredit && mainMenu !== 'Créditos'
        if (creditosConditionToClose) setShowCredit(false)

        const linkConditionToClose =
            showLink && mainMenu !== 'Link de Pagamento'
        if (linkConditionToClose) setShowLink(false)

        handleClickLinkWithMatches()
        dispatch(actions.selectedMenu({ mainMenu, subMenu, currentLink }))
    }
    return (
        <MenuContainer
            className={classNames({ open: isMenuOpen }, { dark: colorDark })}
        >
            <Logo>
                <a href="https://treeweb.com.br/producao/">
                    {isMenuOpen ? (
                        <img src={logoMaior} alt="Logo treepay" />
                    ) : (
                        <img src={logoMenor} alt="Logo treepay" />
                    )}
                </a>
                {collapseMenuIcon && (
                    <button
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        className={classNames({
                            'open ': isMenuOpen,
                        })}
                    >
                        <MdOutlineKeyboardArrowRight size={22} />
                    </button>
                )}
            </Logo>

            <Nav>
                <ul className="">
                    <div className="top">
                        <li>
                            <Link
                                onClick={() =>
                                    handleClickMenu(
                                        'Dashboard',
                                        '',
                                        '/dashboard'
                                    )
                                }
                                className={
                                    mainMenu === 'Dashboard'
                                        ? 'item active'
                                        : 'item'
                                }
                                to="dashboard"
                            >
                                <MdOutlineInsertChartOutlined size={24} />
                                <span
                                    className={classNames('', {
                                        'opacity-0 hidden':
                                            !isMenuOpen && collapseMenuIcon,
                                    })}
                                >
                                    Dashboard
                                </span>
                            </Link>
                        </li>
                        {/* <li>
                            <Link
                                onClick={() => {
                                    setShowCredit(false)
                                    setShowDashboard(true)
                                    handleClickLinkWithMatches()
                                    dispatch(actions.selectedMenu({ mainMenu: 'Dashboard', subMenu: '', currentLink: '/dashboard'}))
                                }}
                                className='item' to="/dashboard">
                                <MdMoving  size={22}/>
                                <span>Dashboard</span>
                                <MdKeyboardArrowRight className={showDashboard ? 'arrow-icon open' : 'arrow-icon'} />
                            </Link>
                            {showDashboard && (
                            <ul className='sub-list'>
                                <li>
                                    <Link
                                        onClick={() => handleClickMenu('Dashboard', 'Gráfico', '/dashboard')}
                                        className={subMenu === 'Gráfico' ? 'item active': 'item'}
                                        to="/dashboard/graficos"
                                    >
                                        <VscGraph />
                                        <span>Gráfico</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        onClick={() => handleClickMenu('Dashboard', 'Histórico', '/dashboard')}
                                        className={subMenu === 'Histórico' ? 'item active': 'item'}
                                        to="/dashboard/historico"
                                    >
                                        <MdOutlineArticle />
                                        <span>Histórico</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        onClick={() => handleClickMenu('Dashboard', 'Agenda', '/dashboard')}
                                        className={subMenu === 'Agenda' ? 'item active': 'item'}
                                        to="/dashboard/agenda"
                                    >
                                        <MdInsertInvitation />
                                        <span>Agenda</span>
                                    </Link>
                                </li>
                            </ul>
                            )}
                        </li> */}
                        {/* <li>
                            <Link
                                onClick={() => {
                                    setShowDashboard(false)
                                    setShowCredit(true)
                                    handleClickLinkWithMatches()
                                    dispatch(actions.selectedMenu({ mainMenu: 'Créditos', subMenu: 'Antecipar', currentLink: '/creditos'}))
                                }}
                                className='item' to="">
                                <FiCreditCard  size={22}/>
                                <span>Créditos</span>
                                <MdKeyboardArrowRight className={showCredit ? 'arrow-icon open' : 'arrow-icon'} />
                            </Link>
                            {showCredit && (
                            <ul className='sub-list'>
                                <li>
                                    <Link
                                        onClick={() => handleClickMenu('Créditos', 'Antecipar', '/creditos')}
                                        className={subMenu === 'Antecipar' ? 'item active': 'item'}
                                        to=""
                                    >
                                        <MdPaid />
                                        <span>Antecipar</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        onClick={() => handleClickMenu('Créditos', 'Extrato', '/creditos')}
                                        className={subMenu === 'Extrato' ? 'item active': 'item'}
                                        to=""
                                    >
                                        <MdRequestPage />
                                        <span>Extrato</span>
                                    </Link>
                                </li>
                            </ul>
                            )}
                        </li> */}
                        <li>
                            <Link
                                onClick={() =>
                                    handleClickMenu(
                                        'Pagamento',
                                        '',
                                        '/pagamento'
                                    )
                                }
                                className={
                                    mainMenu === 'Pagamento'
                                        ? 'item active'
                                        : 'item'
                                }
                                to="pagamento"
                            >
                                <BiDollarCircle size={24} />
                                <span
                                    className={classNames('', {
                                        'opacity-0 hidden':
                                            !isMenuOpen && collapseMenuIcon,
                                    })}
                                >
                                    Pagamento
                                </span>
                            </Link>
                        </li>
                        {/* <li>
                            <Link
                                onClick={() => {
                                    setShowCredit(false)
                                    setShowDashboard(false)
                                    setShowLink(true)
                                    handleClickLinkWithMatches()
                                    dispatch(actions.selectedMenu({ mainMenu: 'Link de Pagamento', subMenu: 'Criar', currentLink: '/link/criar'}))
                                }}
                                className='item' to="/link/criar">
                                <BiLink size={22}/>
                                <span>Link de Pagamento</span>
                                <MdKeyboardArrowRight size={22} className={showLink ? 'arrow-icon open' : 'arrow-icon'} />
                            </Link>
                            {showLink && (
                            <ul className='sub-list'>
                                <li>
                                    <Link
                                        onClick={() => handleClickMenu('Link de Pagamento', 'Criar', '/link')}
                                        className={subMenu === 'Criar' ? 'item active': 'item'}
                                        to="/link/criar"
                                    >
                                        <MdAddLink />
                                        <span>Criar</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        onClick={() => handleClickMenu('Link de Pagamento', 'Aprovar', '/link')}
                                        className={subMenu === 'Aprovar' ? 'item active': 'item'}
                                        to="/link/aprovar"
                                    >
                                        <MdPendingActions />
                                        <span>Aprovar</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        onClick={() => handleClickMenu('Link de Pagamento', 'Gerenciar', '/dashboard')}
                                        className={subMenu === 'Gerenciar' ? 'item active': 'item'}
                                        to="/link/gerenciar"
                                    >
                                        <MdInsertInvitation />
                                        <span>Gerenciar</span>
                                    </Link>
                                </li>
                            </ul>
                            )}
                        </li> */}
                        <li>
                            <Link
                                onClick={() =>
                                    handleClickMenu(
                                        'Cobranças',
                                        '',
                                        '/cobrancas'
                                    )
                                }
                                className={
                                    mainMenu === 'Cobranças'
                                        ? 'item active'
                                        : 'item'
                                }
                                to="/cobrancas"
                            >
                                <BiLink size={24} />
                                <span
                                    className={classNames('', {
                                        'opacity-0 hidden':
                                            !isMenuOpen && collapseMenuIcon,
                                    })}
                                >
                                    Cobranças
                                </span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                onClick={() =>
                                    handleClickMenu(
                                        'Recorrência',
                                        '',
                                        '/recorrencia'
                                    )
                                }
                                className={
                                    mainMenu === 'Recorrência'
                                        ? 'item active'
                                        : 'item'
                                }
                                to="/recorrencia"
                            >
                                <RiExchangeDollarLine size={24} />
                                <span
                                    className={classNames('', {
                                        'opacity-0 hidden':
                                            !isMenuOpen && collapseMenuIcon,
                                    })}
                                >
                                    Recorrência
                                </span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                onClick={() =>
                                    handleClickMenu('Extratos', '', '/extratos')
                                }
                                className={
                                    mainMenu === 'Extratos'
                                        ? 'item active'
                                        : 'item'
                                }
                                to="extratos"
                            >
                                <FiFileText size={24} />
                                <span
                                    className={classNames('', {
                                        'opacity-0 hidden':
                                            !isMenuOpen && collapseMenuIcon,
                                    })}
                                >
                                    Extratos
                                </span>
                            </Link>
                        </li>
                        {/* <li>
                            <Link
                                onClick={() => handleClickMenu('Recebimentos', '', '/recebimentos')}
                                className={mainMenu === 'Recebimentos' ? 'item active': 'item'}
                                to="recebimentos"
                            >
                                <MdReceipt size={22}/>
                                <span>Recebimentos</span>
                            </Link>
                        </li> */}
                        <li>
                            <Link
                                onClick={() =>
                                    handleClickMenu(
                                        'Favoritos',
                                        '',
                                        '/favoritos'
                                    )
                                }
                                className={
                                    mainMenu === 'Favoritos'
                                        ? 'item active'
                                        : 'item'
                                }
                                to="favoritos"
                            >
                                <MdPeopleOutline size={24} />
                                <span
                                    className={classNames('', {
                                        'opacity-0 hidden':
                                            !isMenuOpen && collapseMenuIcon,
                                    })}
                                >
                                    Favoritos
                                </span>
                            </Link>
                        </li>
                    </div>
                    <div className="bottom">
                        <li>
                            <Link
                                onClick={() =>
                                    handleClickMenu(
                                        'Minha conta',
                                        '',
                                        'minhaconta/instituicao'
                                    )
                                }
                                className={
                                    mainMenu === 'Minha conta'
                                        ? 'item active'
                                        : 'item'
                                }
                                to="minhaconta/instituicao"
                            >
                                <FiSettings size={24} />
                                <span
                                    className={classNames('', {
                                        'opacity-0 hidden':
                                            !isMenuOpen && collapseMenuIcon,
                                    })}
                                >
                                    Minha conta
                                </span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                onClick={() => handleClickMenu('Ajuda', '', '')}
                                className={
                                    mainMenu === 'Ajuda'
                                        ? 'item active'
                                        : 'item'
                                }
                                to=""
                            >
                                <MdOutlineHelpOutline size={24} />
                                <span
                                    className={classNames('', {
                                        'opacity-0 hidden':
                                            !isMenuOpen && collapseMenuIcon,
                                    })}
                                >
                                    Ajuda
                                </span>
                            </Link>
                        </li>

                        <li className="toogle">
                            <label
                                htmlFor="toogle-theme"
                                className={classNames('', {
                                    'opacity-0 hidden':
                                        !isMenuOpen && collapseMenuIcon,
                                })}
                            >
                                Tema do menu
                            </label>
                            <Switch
                                checked={colorDark}
                                onChange={(value: boolean) =>
                                    dispatch(
                                        actions.changeColorMenu({
                                            colorDark: value,
                                        })
                                    )
                                }
                                id="toogle-theme"
                                // className={`${
                                //     colorDark ? 'bg-blue-600' : 'bg-gray-200'
                                // } relative inline-flex h-6 w-11 items-center rounded-full`}

                                className={classNames(
                                    'relative inline-flex shrink-0 items-center rounded-full transition-colors duration-400 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75',
                                    { 'bg-green-700': colorDark },
                                    { 'bg-green-500': !colorDark },
                                    { 'h-5 w-11': isMenuOpen },
                                    { 'h-5 w-8': !isMenuOpen }
                                )}
                            >
                                <span className="sr-only">Tema do menu</span>
                                <span
                                    className={classNames(
                                        'inline-flex items-center justify-center h-5 w-5 transform rounded-full bg-white transition shadow-lg ring-0 duration-200 ease-in-out',
                                        {
                                            'translate-x-6 ':
                                                colorDark && isMenuOpen,
                                        },
                                        {
                                            'translate-x-0 ': !colorDark,
                                        },
                                        {
                                            'translate-x-3 ':
                                                colorDark && !isMenuOpen,
                                        }
                                    )}
                                >
                                    {colorDark ? (
                                        <MdOutlineNightlight
                                            color="#333"
                                            size={16}
                                        />
                                    ) : (
                                        <MdOutlineLightMode
                                            color="#333"
                                            size={16}
                                        />
                                    )}
                                </span>
                            </Switch>
                        </li>
                    </div>
                </ul>
            </Nav>
            <span
                className={classNames('close-menu', { dark: colorDark })}
                onClick={() => setIsMenuOpen(false)}
            >
                <MdOutlineClose />
            </span>
        </MenuContainer>
    )
}
